export const FLAG_GETTING_DISTRICTS = 'FLAG_GETTING_DISTRICTS';
export const GET_DISTRICTS = 'GET_DISTRICTS';
export const CLEAR_DISTRICTS = 'CLEAR_DISTRICTS';
export const FLAG_DISTRICT_ACTIVITY = 'FLAG_DISTRICT_ACTIVITY';
export const GET_DISTRICT = 'GET_DISTRICT';
export const CLEAR_DISTRICT = 'CLEAR_DISTRICT';
